import { ExternalShipmentTracker } from "@redotech/redo-order-tracking-trackable-common/trackable";
import { RedoBadgeColor } from "@redotech/redo-web/arbiter-components/badge/redo-badge";

export const trackerStatusColors: {
  [key in ExternalShipmentTracker["status"]]: NonNullable<RedoBadgeColor>;
} = {
  unknown: "error",
  pre_transit: "warning",
  in_transit: "warning",
  out_for_delivery: "warning",
  delivered: "success",
  available_for_pickup: "success",
  return_to_sender: "error",
  failure: "error",
  cancelled: "error",
  error: "error",
  expired: "error",
} as const;
